import styled from 'styled-components'
import { ColumnSpacer } from '../../shared/ui/Spacer'

type CartItemProps = {
  videoTitle: string
  creatorName: string
  videoThumbnailUrl: string
  floorPrice: string
  primary?: boolean
}

// ========================= React Component ===================================

const CartItem = ({
  videoTitle,
  creatorName,
  videoThumbnailUrl,
  floorPrice,
  primary,
}: CartItemProps): JSX.Element => {
  return (
    <BackgroundRectangle>
      <DetailsColumn>
        <TitleLabel>{videoTitle}</TitleLabel>
        <CreatorLabel>
          by <b>{creatorName}</b>
        </CreatorLabel>
        <ColumnSpacer space="12px" />
        <FloorPriceLabel>
          {primary ? '' : 'Floor '}Price: <b>{floorPrice} SOL</b>
        </FloorPriceLabel>
      </DetailsColumn>
      <Thumbnail>
        <VideoThumbnailContainer>
          <VideoThumbnail poster={videoThumbnailUrl} />
        </VideoThumbnailContainer>
      </Thumbnail>
    </BackgroundRectangle>
  )
}

export default CartItem

// ======================= Styled Components ===================================

const BackgroundRectangle = styled.div`
  width: 100%;
  background: #323232;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
`

const DetailsColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 70%;
`

const TitleLabel = styled.div`
  font-size: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 95%;
  font-weight: 600;
  color: #fff;
`

const CreatorLabel = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #fff;
`

const FloorPriceLabel = styled.div`
  font-size: 14px;
  color: #fff;
  font-weight: 400;
`

const Thumbnail = styled.div`
  width: 30%;
  object-fit: fill;
`

const VideoThumbnailContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  border-radius: 10px;
  cursor: pointer;
`

const VideoThumbnail = styled.div<{ poster: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-color: black;
  cursor: pointer;
  background-image: url(${(props) => props.poster});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`
